<bl-modal-content #content
  [title]="headerTitle"
  [footerButtonType]="ModalButtonType.Custom">
  <div body class="main-body">
    <table class="table table-bordered" border="2">
      <tr class="header first">
        <td class="title" colspan="2">コンタクトカレンダーの初期表示を設定してください。</td>
      </tr>
      <tr>
        <th class="header-width">
          <span>実施内容</span>
        </th>
        <td class="impl-content-cell">
          <div class="item_check_group_div">
            <bl-checkbox-group
              [values]="contactInitDisplaySettingDtlCalendar.contactCheckDivList"
              [items]="contactCheckDivArray"
              [option]="{'labelProperty': 'name','valueProperty': 'code'}"
              [groupType]="'inline'"
              (changeEvent)="onChangeCalendarContactCheckDivArray($event)"
            ></bl-checkbox-group>
            <div class="multi_select">
              <bl-multi-select
                [values]="contactInitDisplaySettingDtlCalendar.contactExecuteItemCodeList"
                [items]="contactImplDivArray"
                [option]="{labelProperty: 'name', valueProperty: 'code'}"
                (changeEvent)="onChangeCalendarContactImplDiv($event)"
              ></bl-multi-select>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>組織</span>
          <span class="label-tag-required"></span>
        </th>
        <td>
          <div class="half_length">
            <share-organization-combo-box
              [withAllCompanyDiv]="WithAllCompanyDiv.None"
              [(value)]="contactInitDisplaySettingDtlCalendar.organizationCode"
              [officeControl]="false"
            ></share-organization-combo-box>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>担当者</span>
        </th>
        <td>
          <div class="item_check_div">
            <div>
              <bl-checkbox
                [label]="'ログイン担当者を使用する'"
                [checked]="employeeDisableFlgCalendar"
                (changeEvent)="onChangeEmployeeFlg($event.target.checked, 'calendar')"
              ></bl-checkbox>
            </div>
            <div class="input-group form-size--l">
              <bl-text-input
                [(value)]="calendarPicName"
                [maxlength]="60"
                [disabled]="employeeDisableFlgCalendar"
                [placeholder]="'従業員コード'"
                (changeEvent)="changePicCode('calendar', $event)"
              ></bl-text-input>
              <span class="input-group-btn">
                <button
                  #employeeGuideButton
                  class="btn btn-default" type="button"
                  [disabled]="employeeDisableFlgCalendar"
                  (click)="onClickEmployeeGuide('calendar', employeeGuideButton)">
                  <span class="icon-icon_guide glyphicon"></span>
                </button>
              </span>
            </div>
          </div>
        </td>
      </tr>
      <tr class="header second">
        <td class="title" colspan="2">コンタクト一覧の初期表示を設定してください。</td>
      </tr>
      <tr>
        <th class="header-width">
          <span>実施内容</span>
        </th>
        <td class="impl-content-cell">
          <div class="item_check_group_div">
            <bl-checkbox-group
              [values]="contactInitDisplaySettingDtlGrid.contactCheckDivList"
              [items]="contactCheckDivArray"
              [option]="{'labelProperty': 'name','valueProperty': 'code'}"
              [groupType]="'inline'"
              (changeEvent)="onChangeGridContactCheckDivArray($event)"
            ></bl-checkbox-group>
            <div class="multi_select">
              <bl-multi-select
                [values]="contactInitDisplaySettingDtlGrid.contactExecuteItemCodeList"
                [items]="contactImplDivArray"
                [option]="{labelProperty: 'name', valueProperty: 'code'}"
                (changeEvent)="onChangeGridContactImplDiv($event)"
              ></bl-multi-select>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>期間の基準</span>
        </th>
        <td>
          <div class="half_length">
            <bl-select
              [(value)]="contactInitDisplaySettingDtlGrid.contactDateSearchDiv"
              [items]="CONTACT_DATE_SEARCH_DIV_LIST"
              [option]="{ labelProperty: 'name', valueProperty: 'code' }"
            ></bl-select>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>対象期間</span>
          <span class="label-tag-required"></span>
        </th>
        <td>
          <div class="item_check_div">
            <div class="apply_select_fst">
              <!-- 適用開始期間基準区分 -->
              <bl-select
                [(value)]="contactInitDisplaySettingDtlGrid.applyStartPeriodCriteriaDiv"
                [items]="applyPeriodCriteriaDivItems"
              ></bl-select>
            </div>
            <div class="apply_number_length">
              <bl-number-input
                [(value)]="contactInitDisplaySettingDtlGrid.applyStartNum"
                [option]="{ minus: false, min: 0, max: 99 }"
                [disabled]="isApplyStartPeriodToday"
              ></bl-number-input>
            </div>
            <div class="apply_select_lst">
              <!-- 月週日区分 -->
              <bl-select
                [(value)]="contactInitDisplaySettingDtlGrid.monthWeekDayDiv"
                [items]="monthWeekDayDivItems"
                [disabled]="isApplyStartPeriodToday"
              ></bl-select>
            </div>
            <span class="from_to">～</span>
            <div class="apply_select_fst">
              <!-- 適用終了期間基準区分 -->
              <bl-select
                [(value)]="contactInitDisplaySettingDtlGrid.applyEndPeriodCriteriaDiv"
                [items]="applyPeriodCriteriaDivItems"
              ></bl-select>
            </div>
            <div class="apply_number_length">
              <bl-number-input
                [(value)]="contactInitDisplaySettingDtlGrid.applyEndNum"
                [option]="{ minus: false, min: 0, max: 99 }"
                [disabled]="isApplyEndPeriodToday"
              ></bl-number-input>
            </div>
            <div class="apply_select_lst">
              <!-- 月週日区分 -->
              <bl-select
                [(value)]="contactInitDisplaySettingDtlGrid.monthWeekDayDiv"
                [items]="monthWeekDayDivItems"
                [disabled]="isApplyEndPeriodToday"
              ></bl-select>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>組織</span>
        </th>
        <td class="grid-list-cell-truncate">
          <share-organization-multi-select
            [values]="gridOrganizationCodes"
            [enableAllCheckbox]="true"
            [enableFilter]="true"
            [option]="{ parentSelector: 'body', dropup: false }"
            (readyEvent)="onOrganizationMultiSelectReady($event)"
            (changeEvent)="onChangeOrganizationMultiSelect($event)"
          ></share-organization-multi-select>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>担当者</span>
        </th>
        <td>
          <div class="item_check_div">
            <div>
              <bl-checkbox
                [label]="'ログイン担当者を使用する'"
                [checked]="employeeDisableFlgContactList"
                (changeEvent)="onChangeEmployeeFlg($event.target.checked, 'contactList')"
              ></bl-checkbox>
            </div>
            <div class="input-group form-size--l">
              <bl-text-input
                [value]="contactListPicName"
                [option]="{ maxLength: 60 }"
                [disabled]="employeeDisableFlgContactList"
                [placeholder]="'従業員コード'"
                (changeEvent)="changePicCode('contactList', $event)"
              ></bl-text-input>
              <span class="input-group-btn">
                <button
                  #employeeGuideButton
                  class="btn btn-default" type="button"
                  [disabled]="employeeDisableFlgContactList"
                  (click)="onClickEmployeeGuide('contactList', employeeGuideButton)">
                  <span class="icon-icon_guide glyphicon"></span>
                </button>
              </span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>顧客ラベル</span>
        </th>
        <td>
          <share-label-select-input
            [selectedCodeList]="contactInitDisplaySettingDtlGrid.customerLabelCodeList"
            [labelUseCategory]="[LabelUseCategory.Customer]"
            [option]="{ previewNum: 5, parentAutoCheck: true }"
            (changeCodeListEvent)="onChangeCustomerLabel($event)"
          ></share-label-select-input>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>コンタクト区分</span>
        </th>
        <td class="grid-list-cell-truncate">
          <app-org-master-select-search
            [masterKind]="OrgMasterKind.ContactItem"
            [contactListPageService]="orgMasterContactListPageService"
            [organizationCodes]="gridOrganizationCodes"
            [refreshToken]="orgMasterRefreshToken"
            [placeholder]="'コンタクト区分'"
            [(selectedKeys)]="contactItemOrgMasterKeys"
            (selectedKeysChange)="onChangeContactItemOrgMasterKeys($event)"
          ></app-org-master-select-search>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>実施手段</span>
        </th>
        <td>
          <bl-multi-select
            [values]="contactInitDisplaySettingDtlGrid.contactDivDetailCodeList"
            [items]="_contactDivSettingList"
            [option]="{ valueProperty: 'contactDivDetailCode', labelProperty: 'contactDivDetailCodeName' }"
            [placeholder]="'選択してください'"
            (changeItemsEvent)="onChangeContactDivSetting($event)"
          ></bl-multi-select>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>失注理由</span>
        </th>
        <td class="grid-list-cell-truncate">
          <app-org-master-select-search
            [masterKind]="OrgMasterKind.LostReason"
            [contactListPageService]="orgMasterContactListPageService"
            [organizationCodes]="gridOrganizationCodes"
            [refreshToken]="orgMasterRefreshToken"
            [placeholder]="'失注理由'"
            [(selectedKeys)]="contactLostReasonOrgMasterKeys"
            (selectedKeysChange)="onChangeContactLostReasonOrgMasterKeys($event)"
          ></app-org-master-select-search>
        </td>
      </tr>
      <tr *ngIf="isAvailableMaintePack">
        <th class="header-width">
          <span>メンテナンスパック</span>
        </th>
        <td>
          <bl-radio-group
            [(value)]="contactInitDisplaySettingDtlGrid.contactExtractMPExistDiv"
            [items]="CONTACT_EXTRACT_TARGET_MP_EXIST_DIV_LIST"
            [option]="{ labelProperty: 'name', valueProperty: 'code' }"
            [groupType]="'inline'"
          ></bl-radio-group>
        </td>
      </tr>
      <tr *ngIf="isAvailableEntrustedLease">
        <th class="header-width">
          <span>リース情報</span>
        </th>
        <td>
          <bl-radio-group
            [(value)]="contactInitDisplaySettingDtlGrid.contactExtractEntrustedContractExistDiv"
            [items]="CONTACT_EXTRACT_TARGET_ENTRUSTED_CONTRACT_EXIST_DIV_LIST"
            [option]="{ labelProperty: 'name', valueProperty: 'code' }"
            [groupType]="'inline'"
          ></bl-radio-group>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>顧客DM案内可否</span>
        </th>
        <td>
          <div class="half_length">
            <bl-select
              [(value)]="contactInitDisplaySettingDtlGrid.contactExtractCustomerDmSendDiv"
              [items]="_customerDmSendDivList"
            ></bl-select>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>車両DM案内可否</span>
        </th>
        <td>
          <div class="half_length">
            <bl-select
              [(value)]="contactInitDisplaySettingDtlGrid.contactExtractVehicleDmSendDiv"
              [items]="_vehicleDmSendDivList"
            ></bl-select>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>顧客名フリガナ</span>
        </th>
        <td>
          <bl-text-input
            [(value)]="contactInitDisplaySettingDtlGrid.customerNameKana1"
            [option]="{ allows: ['katakana', 'number', 'alphabet', 'symbol'], convertKana: true }"
          ></bl-text-input>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>抽出結果の並び順</span>
        </th>
        <td>
          <div class="half_length">
            <bl-select
              [(value)]="contactInitDisplaySettingDtlGrid.contactExtractResultSortOrderDiv"
              [items]="SORT_ORDER_DIV_LIST"
              [option]="{ valueProperty: 'value', labelProperty: 'text' }"
            ></bl-select>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div footer>
    <button class="btn btn-default" type="button"
      (click)="content.cancel()">キャンセル
    </button>
    <button class="btn btn-default" type="button"
      (click)="onClear()">設定をクリア
    </button>
    <button class="btn btn-success" type="button"
      (click)="content.done()">決定
    </button>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/contact-init-setting/contact-init-setting-modal.component.html